export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

export function getDeviceId(): string {
  if (typeof window !== 'undefined') {
    let deviceId = localStorage.getItem('tula_device_id');
    if (!deviceId) {
      deviceId = generateId();
      localStorage.setItem('tula_device_id', deviceId);
    }
    return deviceId;
  }
  return generateId();
}

export function getPlatform(overridePlatform?: 'ios' | 'android' | 'both'): 'ios' | 'android' | 'both' {
  console.log('[DEBUG] getPlatform called with override:', overridePlatform);
  
  // If platform is explicitly provided, use it
  if (overridePlatform) {
    console.log('[DEBUG] Using override platform:', overridePlatform);
    return overridePlatform;
  }
  
  // Check for React Native environment first
  console.log('[DEBUG] Checking React Native environment...');
  console.log('[DEBUG] typeof global:', typeof global);
  console.log('[DEBUG] global.__DEV__:', typeof global !== 'undefined' ? (global as any).__DEV__ : 'global undefined');
  
  // @ts-ignore - React Native global
  if (typeof global !== 'undefined' && (global as any).__DEV__ !== undefined) {
    console.log('[DEBUG] React Native environment detected');
    // This is React Native, check the Platform if available
    try {
      // @ts-ignore - React Native Platform
      const Platform = require('react-native').Platform;
      console.log('[DEBUG] React Native Platform.OS:', Platform?.OS);
      if (Platform?.OS === 'ios') {
        console.log('[DEBUG] Returning ios from React Native Platform');
        return 'ios';
      }
      if (Platform?.OS === 'android') {
        console.log('[DEBUG] Returning android from React Native Platform');
        return 'android';
      }
    } catch (e) {
      console.log('[DEBUG] Failed to import React Native Platform:', e);
    }
  }
  
  console.log('[DEBUG] typeof window:', typeof window);
  if (typeof window === 'undefined') {
    console.log('[DEBUG] No window, returning both');
    return 'both';
  }
  
  // Check navigator.platform first (more reliable)
  const platform = window.navigator?.platform?.toLowerCase() || '';
  console.log('[DEBUG] navigator.platform:', window.navigator?.platform, '-> lowercased:', platform);
  if (/iphone|ipad|ipod/.test(platform)) {
    console.log('[DEBUG] Returning ios from navigator.platform');
    return 'ios';
  }
  if (/android/.test(platform)) {
    console.log('[DEBUG] Returning android from navigator.platform');
    return 'android';
  }
  
  // Fallback to userAgent
  const userAgent = window.navigator?.userAgent?.toLowerCase() || '';
  console.log('[DEBUG] navigator.userAgent:', window.navigator?.userAgent, '-> lowercased:', userAgent);
  if (/iphone|ipad|ipod/.test(userAgent)) {
    console.log('[DEBUG] Returning ios from userAgent');
    return 'ios';
  }
  if (/android/.test(userAgent)) {
    console.log('[DEBUG] Returning android from userAgent');
    return 'android';
  }
  
  console.log('[DEBUG] No platform detected, returning both');
  return 'both';
}

export function getAppVersion(): string | undefined {
  if (typeof window !== 'undefined' && window.location) {
    const params = new URLSearchParams(window.location.search);
    return params.get('app_version') || undefined;
  }
  return undefined;
}

export function debugLog(debug: boolean | undefined, ...args: any[]): void {
  if (debug && typeof console !== 'undefined') {
    console.log('[Tula SDK]', ...args);
  }
}